module.exports = __webpack_public_path__ + "img/vertical_3_7_6005.be5cbbf4.png";